import ScreenLayout from 'components/ScreenLayout'
import { CollectiveProvider } from 'context/CollectiveContext'
import { NextPage } from 'next'
import { withAuthServerSideProps } from 'hoc/withAuthServerSideProps'
import NavbarLayout from 'components/NavbarLayout'
import CollectiveEvents from 'components/Collectives/CollectiveEvents'
import MembershipGate from 'components/Collectives/MembershipGate/MembershipGate'

interface IProps {
  collectiveId: string
}

const CollectiveProposalPage: NextPage<IProps> = ({ collectiveId }) => {
  return (
    <CollectiveProvider collectiveId={collectiveId}>
      <NavbarLayout stuckClasses="bg-gray-100">
        <ScreenLayout>
          <MembershipGate
            header="Events Calendar is Hidden"
            subheader="The Events Calendar is only visible to members of the DAO."
          >
            <CollectiveEvents />
          </MembershipGate>
        </ScreenLayout>
      </NavbarLayout>
    </CollectiveProvider>
  )
}

export default CollectiveProposalPage

export const getServerSideProps = withAuthServerSideProps(
  async function getServerSideProps(ctx) {
    return {
      props: {
        collectiveId: ctx.query.collectiveId as string
      }
    }
  }
)
